export default "__VITE_ASSET__CGG$evYT__"